import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Badge as BaseBadge } from '@leroy-merlin-br/backyard-react-ui'

const descriptionButtonStyles = () => css`
  label: filter-title__description-button;

  cursor: pointer;
  display: inline-block;
`

const badgeStyles = ({ theme }) => css`
  label: filter-title__badge;

  display: flex;

  background-color: ${theme.colors.p200};
`

export const DescriptionButton = styled('span')(descriptionButtonStyles)
export const Badge = styled(BaseBadge)(badgeStyles)
